module.exports = {
      id: "magazines-usage",
      viewBox: "0 0 25.36 20.288",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#magazines",
      toString: function () {
        return this.url;
      }
    }